import { Box } from "@radix-ui/themes";
import { ReactNode } from "react";

interface CartSectionProps {
  children: ReactNode;
  headerContent?: ReactNode;
}

export const CartSection = ({ children, headerContent }: CartSectionProps) => {
  return (
    <>
      <Box height="24px" className="flex items-center justify-end" pr="2">
        {headerContent}
      </Box>
      {children}
    </>
  );
};
